import { gql } from '@apollo/client';

export const GET_CONSULTAS = gql`
    query GetAllConsultas {
        allConsultasActivas {
            idConsulta
            nombre
            descripcion
            activo
        }
    }
`;